module.exports = __webpack_public_path__ + "img/background1.ea05c66b.png";